export const messages = {
  en: {
    dataReport: {
      timeRange: 'Time Range',
      startDate: 'Start Date',
      endDate: 'End Date',
      to: 'to',
      selectCommunity: 'Select Community',
      today: 'Today',
      yesterday: 'Yesterday',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      feeStatistics: 'Fee Statistics',
      orderStatistics: 'Order Statistics',
      inoutStatistics: 'In/Out Statistics',
      otherStatistics: 'Other Statistics',
      building: 'Building',
      roomCount: 'Room Count',
      feeRoomCount: 'Fee Room Count',
      receivedFee: 'Received Fee',
      totalReceived: 'Total Received',
      export: 'Export',
      roomNumber: 'Room Number',
      ownerName: 'Owner Name',
      phoneNumber: 'Phone Number',
      search: 'Search',
      reset: 'Reset',
      room: 'Room',
      owner: 'Owner',
      oweFee: 'Owe Fee',
      totalOwe: 'Total Owe',
      historyOwe: 'History Owe',
      todayPaidCount: 'Today Paid Count',
      todayPaidAmount: 'Today Paid Amount',
      historyPaidCount: 'History Paid Count',
      historyPaidAmount: 'History Paid Amount',
      monthPaidCount: 'Month Paid Count',
      remainingCount: 'Remaining Count',
      paidRatio: 'Paid Ratio',
      monthPaidAmount: 'Month Paid Amount',
      monthRemaining: 'Month Remaining',
      collectionRate: 'Collection Rate',
      feeName: 'Fee Name',
      receivedPeriod: 'Received Period',
      cashier: 'Cashier',
      paymentTime: 'Payment Time',
      owePeriod: 'Owe Period',
      oweAmount: 'Owe Amount',
      receivedAmount: 'Received Amount',
      selectBuilding: 'Select Building',
      feeStartDate: 'Fee Start Date',
      feeEndDate: 'Fee End Date',
      noExportData: 'No data to export',
      tab: {
        earnedStatistics: 'Received Statistics',
        earnedDetail: 'Received Detail',
        earnedWay: 'Payment Method',
        oweStatistics: 'Owe Statistics',
        oweDetail: 'Owe Detail',
        feeStatistics: 'Collection Status',
        monthReceived: 'Monthly Received Detail',
        monthOwe: 'Monthly Owe Detail'
      },
      pageTotalLabel: 'Total on this page',
      allTotalLabel: 'Total (from server)',
      currentPageSummary: 'Total on this page',
      pageUnit: 'records',
      earnedWayChartTitle: 'Payment Method Breakdown',
      earnedWayChartSubtitle: 'Share of received amount by payment method',
      earnedWayNoData: 'No payment method data',
      earnedWaySummary: 'Total received',
      pageTitle: 'Data Statistics Report',
      pageSubtitle: 'By payment time; amounts in yuan',
      headlineDesc: 'Current filter range, same source as below',
      scopeLabel: 'Stats range: {start} to {end}',
      moreTitle: 'More indicators ({count})',
      floorRankTitle: 'Building Received Ranking',
      floorRankSubtitle: 'Top 10 buildings by received amount, full data',
      floorRankNoData: 'No building received data',
      floorRankSummary: 'Top10 total'
    }
  },
  zh: {
    dataReport: {
      timeRange: '统计时间',
      startDate: '开始日期',
      endDate: '结束日期',
      to: '至',
      selectCommunity: '请选择小区',
      today: '今日',
      yesterday: '昨日',
      last7Days: '近7日',
      last30Days: '近30日',
      feeStatistics: '费用类统计',
      orderStatistics: '工单类统计',
      inoutStatistics: '出入统计',
      otherStatistics: '其他统计',
      building: '楼栋',
      roomCount: '户数',
      feeRoomCount: '收费户数',
      receivedFee: '实收',
      totalReceived: '总实收',
      export: '导出',
      roomNumber: '房屋编号',
      ownerName: '业主名称',
      phoneNumber: '手机号',
      search: '查询',
      reset: '重置',
      room: '房屋',
      owner: '业主',
      oweFee: '欠费',
      totalOwe: '总欠费',
      historyOwe: '历史欠费',
      todayPaidCount: '本日已交户数',
      todayPaidAmount: '本日已交金额',
      historyPaidCount: '历史欠费清缴户',
      historyPaidAmount: '历史欠费清缴金额',
      monthPaidCount: '本月已收户数',
      remainingCount: '剩余户数',
      paidRatio: '已收户占比',
      monthPaidAmount: '当月已收金额',
      monthRemaining: '当月剩余未收',
      collectionRate: '收费率',
      feeName: '费用名称',
      receivedPeriod: '实收时间段',
      cashier: '收银员',
      paymentTime: '交费时间',
      owePeriod: '欠费时间段',
      oweAmount: '欠费金额',
      receivedAmount: '实收',
      selectBuilding: '请选择楼栋',
      feeStartDate: '费用开始时间',
      feeEndDate: '费用结束时间',
      noExportData: '没有可以导出的数据',
      tab: {
        earnedStatistics: '实收统计',
        earnedDetail: '实收明细',
        earnedWay: '收款方式统计',
        oweStatistics: '欠费统计',
        oweDetail: '欠费明细',
        feeStatistics: '收缴情况',
        monthReceived: '月实收明细',
        monthOwe: '月欠费明细'
      },
      pageTotalLabel: '本页合计',
      allTotalLabel: '全量合计（后端）',
      currentPageSummary: '本页合计',
      pageUnit: '条',
      earnedWayChartTitle: '收款方式构成',
      earnedWayChartSubtitle: '各收款方式实收金额占比',
      earnedWayNoData: '暂无收款方式数据',
      earnedWaySummary: '实收合计',
      pageTitle: '数据统计报表',
      pageSubtitle: '统计口径：按缴费时间归集，金额单位元',
      headlineDesc: '当前筛选区间，与下方明细同源',
      scopeLabel: '统计范围：{start} 至 {end}',
      moreTitle: '更多指标（{count} 项）',
      floorRankTitle: '楼栋实收排行',
      floorRankSubtitle: '按实收金额 Top10，全量数据',
      floorRankNoData: '暂无楼栋实收数据',
      floorRankSummary: 'Top10 合计'
    }
  }
}